import React from 'react';
import { useHistory } from 'react-router-dom';
import Box from 'Components/Atoms/Box';
import Typography from 'Components/Atoms/Typography';
import Button from 'Components/Atoms/Button';
import { Warning } from 'Components/Atoms/Icons';
import useAuth from 'CustomHooks/useAuth';
import useRestaurant from 'CustomHooks/useRestaurant';
import useGuestbookVersion from 'CustomHooks/useGuestbookVersion';
import './styles.scss';

const GuestbookUpgradeBanner: React.FC = () => {
  const { isAdmin } = useAuth();
  const { restaurantId } = useRestaurant();
  const { version } = useGuestbookVersion();
  const history = useHistory();

  if (!isAdmin || version !== 'v01' || !restaurantId) {
    return null;
  }

  const handleUpgrade = () => {
    history.push(`/${restaurantId}/settings/general/apps?appId=guestbook`);
  };

  return (
    <Box className="guestbook-upgrade-banner" role="alert">
      <Warning className="guestbook-upgrade-banner__icon" />
      <Box className="guestbook-upgrade-banner__content">
        <Typography
          variant="text-2"
          weight="bold"
          translation="dashboard"
          className="guestbook-upgrade-banner__title"
        >
          Guestbook 2.0 is now available
        </Typography>
        <Typography
          variant="text-3"
          translation="dashboard"
          component="p"
          className="guestbook-upgrade-banner__description"
        >
          The new improved Guestbook from Gastronaut – included in your plan.
        </Typography>
      </Box>
      <Button
        variant="primary"
        translation="dashboard"
        onClick={handleUpgrade}
        className="guestbook-upgrade-banner__cta"
      >
        Activate now
      </Button>
    </Box>
  );
};

export default GuestbookUpgradeBanner;
